import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { LoaderService } from './core/services/loader-service/loader-service';
import { Spinner } from './core/components/spinner/spinner/spinner';
import { AsyncPipe } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    MatSlideToggleModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSnackBarModule,
    Spinner,
    MatProgressBarModule,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  standalone: true,
})
export class AppComponent {
  title = 'hr-suit-web';
  isLoading: boolean = false;
  message: string = '';

  width = signal(window.innerWidth);

  constructor(public loaderService: LoaderService) {
    this.loaderService.isLoading$.subscribe({
      next: (data) => {
        if (data) {
          this.isLoading = data?.isLoading;
          this.message = data?.message || '';
        }
      },
    });
  }
}
